const LEGACY_DEPARTMENTS = [
  'Engineering',
  'Human Resources',
  'Finance',
  'Marketing',
  'Operations',
  'Sales',
  'Others',
];

const NEW_DEPARTMENTS = [
  'Purchase',
  'Finance & Accounts',
  'Electricals',
  'Mechanical',
  'Administration',
];

const LEGACY_DESIGNATIONS = [
  'Software Engineer',
  'Senior Engineer',
  'Team Lead',
  'HR Executive',
  'HR Manager',
  'Accountant',
  'Finance Manager',
  'Marketing Exec',
  'Operations Lead',
  'Sales Executive',
];

const NEW_DESIGNATIONS = [
  'Cashier',
  'Driver',
  'Cook',
  'Office Boy',
  'Site Incharge',
  'Site Engineer',
  'Sr Site Engineer',
  'Electrician',
  'Sweeper',
  'Security Guard',
  'Security Gun Man',
  'Sr. Marketting Executive',
  'Marketing Executive',
  'Gardner',
  'Sr. Supervisor',
  'Supervisor',
  'Sr. Accountant',
  'Chief Accountant',
];

const mergeUniqueOptions = (...lists) => {
  const seen = new Set();
  const merged = [];
  for (const list of lists) {
    for (const item of list) {
      if (!item || seen.has(item)) continue;
      seen.add(item);
      merged.push(item);
    }
  }
  return merged;
};

export const DEPARTMENTS = mergeUniqueOptions(LEGACY_DEPARTMENTS, NEW_DEPARTMENTS);

export const DESIGNATIONS = mergeUniqueOptions(LEGACY_DESIGNATIONS, NEW_DESIGNATIONS);

/** Include a saved value in dropdown options when editing legacy records. */
export const withCurrentOption = (options, currentValue) => {
  const value = String(currentValue ?? '').trim();
  if (!value || options.includes(value)) return options;
  return [value, ...options];
};
